<template>
    <div class="py-2">
        <template v-for="(link, index) in links">
            <router-link

                :to="link.to"
                v-slot="{ href, route, navigate, isActive, isExactActive }"
                custom
            >
                    <a v-if="checkLink(route)" class="py-2 flex items-center text-sm transition duration-500 ease-in-out  hover:opacity-75" :class="[isActive || isExactActive ? activeClass : 'text-neutral-default', index != 0 ? 'border-t' : '']" :href="href" @click="navigate">
                        {{ link.name }}
                    </a>
            </router-link>
        </template>
    </div>
</template>

<script>
import {useStore} from "vuex";
import {computed} from "vue";

export default {
    props: {
        links: Object
    },
    data() {
        return {
            menuShow: false,
            activeClass: 'text-black'
        }
    },
    setup (props) {

        const links = props.links;
        const store = useStore();
        const loggedIn = computed(() => store.getters['Customer/isLoggedIn'])

        const checkLink = (route) => {
            if(route.meta){
                if(route.meta.onlyGuest && loggedIn.value || route.meta.requiresAuth && !loggedIn.value){

                    return false;
                }
            }
            return true;
        }

        return{
            links,
            checkLink
        }
    }
}
</script>

<style scoped>

</style>
